import React from "react";
import StarRating from "../Form/StarRating";
import { currencyFormatter } from "../../utils/formatting";
import ProfileImage from "../Common/ProfileImage";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";

function TaskerProfileReview({
  customerFeedback,
  rating,
  createdAt,
  price,
  firstName,
  lastName,
  profilePicture,
}) {
  return (
    <>
      <div className="main-container mb-[14px] p-[24px] rounded-[12px] border-[1px] border-[#DDE1E6] flex flex-col gap-[24px]">
        <div className="flex gap-[16px] border-b-[1px] border-[#DDE1E6] pb-[12px]">
          <div className="flex justify-center items-center w-[64px] h-[64px] rounded-full ">
            <ProfileImage
              profilePicture={profilePicture}
              firstName={firstName}
              lastName={lastName}
              fontSize="text-[20px]"
            />
          </div>
          <div className="flex flex-col gap-[4px]">
            <p className="text-[#0F161E] font-inter font-semibold text-[18px]">{`${firstName} ${lastName}`}</p>
            <p className="text-[#4A4A4A] font-inter font-normal text-[16px]">
              Homeowner
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-row gap-[16px] ">
            <div className="justify-center items-center">
              <StarRating rating={rating} />
            </div>
            <p className="font-inter text-[16px] text-[#4A4A4A]">{rating}</p>
          </div>
          <p className="text-[#4A4A4A] font-inter font-normal text-[16px]">
            {customerFeedback}
          </p>
          <div className="flex flex-row gap-[40px]">
            <div className="flex flex-col">
              <p className="font-inter font-semibold text-[16px] text-[#4A4A4A] ">
                Date
              </p>
              <p className="text-[#4A4A4A] font-inter font-normal text-[14px]">
                {formatYYYY_MM_DD(createdAt)}
              </p>
            </div>
            <div className="flex flex-col">
              <p className="font-inter font-semibold text-[16px] text-[#4A4A4A] ">
                Price
              </p>
              <p className="text-[#4A4A4A] font-inter font-normal text-[14px]">
                {currencyFormatter.format(price)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TaskerProfileReview;
